import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import AllRoutes from "./Pages/Routes/AllRoutes";
import ModernHeader from "./Pages/Header/ModernHeader.tsx";
import Footer from "./Components/Footer/Footer";
import { AuthProvider } from "./contexts/AuthContext";

// Surfaces that own their whole viewport — auth screens and the admin console —
// render without the marketing shell.
const BARE_PATHS = [
  "/login",
  "/admin-login",
  "/admin-dash",
  "/forgot-password",
  "/reset-password",
  "/accept-invitation",
  "/unsubscribe",
  "/user-management",
];

function useIsBare() {
  const { pathname } = useLocation();
  return BARE_PATHS.includes(pathname);
}

// Routes are lazy-loaded, so without this a deep-scrolled visitor lands
// mid-page on the next route. Jump instantly — the CSS smooth-scroll is for
// in-page anchors, not navigation.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function HeaderWrapper() {
  return useIsBare() ? null : <ModernHeader />;
}

function FooterWrapper() {
  return useIsBare() ? null : <Footer />;
}

function App() {
  return (
    <div className="app-container">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <HeaderWrapper />
          <main className="main-content">
            <AllRoutes />
          </main>
          <FooterWrapper />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
